import { AchieveLink } from 'components/AchieveLink'
import { mainProductConfig } from 'constants/mainProductConfig'
import { useContext, useEffect, useState } from 'react'
import { LayoutContext } from 'providers/LayoutProvider'
import { Button } from '@achieve/ascend'
import { Typography } from 'components/Typography'
import { MediaImageStandard } from 'components/Contentful'
import { Typography as OwnerTypography } from 'components/Contentful'
import useIsAnyElementVisible from 'hooks/useIsAnyElementVisible'
import classNames from 'classnames'
import useLayoutMenuCondensed from 'hooks/useLayoutMenuCondensed'

export default function HeaderSticky({
  CurrentSvg,
  tp_text,
  tp_title,
  tp_image,
  linkUrl,
  linkText,
  subLinkText,
  className,
}) {
  const { state: { siteEnv } = {} } = useContext(LayoutContext)
  const isBannerOrModalVisible = useIsAnyElementVisible(['[isCta="true"]'])
  const [layoutMenuCondensed] = useLayoutMenuCondensed()
  const [notVisibleCtaButton, setNotVisibleCtaButton] = useState(false)

  useEffect(() => {
    setNotVisibleCtaButton(!isBannerOrModalVisible)
  }, [isBannerOrModalVisible])

  return (
    <div
      id="mega-menu-header-sticky"
      className={classNames(
        'fixed left-0 right-0 z-50 py-4 px-6 shadow-[0_2px_2px_-2px_rgba(0,0,0,0.25)] hidden bg-white',
        notVisibleCtaButton && layoutMenuCondensed ? 'lg:block' : 'hidden',
        className
      )}
    >
      <div className="flex flex-col-reverse lg:flex-row justify-between mx-auto max-w-[1280px]">
        <div className="hidden lg:flex gap-10 items-center">
          {CurrentSvg && (
            <AchieveLink
              track={{
                ...{
                  list_name: 'Mega Menu Header Logo',
                  click_id: `${mainProductConfig[siteEnv || 'achieve']?.['HeaderLogo']}`,
                  click_text: `${
                    mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
                  } | Mega Menu Header logo`,
                  nav_link_section: 'Mega Menu',
                  track_event: 'mega_menu',
                  event_action: 'link_click',
                  event_type: 'link_click',
                },
              }}
              noLink
              withNextLink
              className={''}
              data-testid={`${String(
                mainProductConfig[siteEnv || 'achieve']?.['MainName']
              )?.toLowerCase()}-mega-menu-header-logo`}
            >
              {CurrentSvg}
            </AchieveLink>
          )}
          <div className="flex flex-col gap-2">
            {tp_title && (
              <div>
                <OwnerTypography variant="bodyMd" className="text-black" content={tp_title} />
              </div>
            )}
            {tp_image && (
              <div className="flex flex-row gap-2 hidden lg:block">
                <div className="flex flex-row gap-2 items-center justify-center">
                  <div className="w-[165px] h-[20px]">
                    <MediaImageStandard content={tp_image} />
                  </div>
                  <OwnerTypography variant="bodyXs" className="text-black" content={tp_text} />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-2 items-center">
          <AchieveLink
            className=""
            href={linkUrl}
            data-testid="mega-menu-header-sticky-cta"
            track={{
              list_name: 'Mega Menu Header CTA Button',
              click_id: linkText,
              click_text: linkText,
              nav_link_section: 'Header',
              track_event: 'mega_menu',
              event_action: 'button_click',
              event_type: 'button_click',
            }}
          >
            <Button color="primary" variant="contained" className="bg-[#0F4C81] px-16 rounded-md">
              <Typography variant="bodySm" className="text-white" fontWeight="bold">
                {linkText}
              </Typography>
            </Button>
          </AchieveLink>
          {subLinkText && (
            <OwnerTypography variant="bodySm" fontWeight="bold" content={subLinkText} />
          )}
        </div>
      </div>
    </div>
  )
}
